import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GerenciaArquivo, GerenciaArquivoUsuario } from 'src/app/@shared/models/gerencia-arquivo/gerencia-arquivo';
import { InserirUsuarioInput } from 'src/app/@shared/models/usuario.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class GerenciaArquivoService {


  constructor(private http: HttpClient) { }

  upLoadArquivo(file: FormData): Observable<GerenciaArquivo> {
    return this.http.post<GerenciaArquivo>(`GerenciaArquivoBanco/UploadArquivoGerencia`, file);
  }

  registraArquivo(obj: GerenciaArquivo): Observable<GerenciaArquivo> {
    return this.http.post<GerenciaArquivo>(`GerenciaArquivoBanco/CadastraArquivo`, obj, httpOptions);
  }

  atualizaArquivo(obj: GerenciaArquivo): Observable<GerenciaArquivo> {
    return this.http.put<GerenciaArquivo>(`GerenciaArquivoBanco/AtualizaArquivo`, obj, httpOptions);
  }

  obterPorClienteId(clienteId: number): Observable<GerenciaArquivo[]> {
    return this.http.get<GerenciaArquivo[]>(`GerenciaArquivoBanco/ObterArquivosPorClienteId/${clienteId}`, httpOptions);
  }

  obterUsuarioPorClienteId(clienteId: number): Observable<InserirUsuarioInput[]> {
    return this.http.get<InserirUsuarioInput[]>(`GerenciaArquivoBanco/ObterUsuariosPorClienteId/${clienteId}`, httpOptions);
  }

  removeArquivo(id: number): Observable<GerenciaArquivo> {
    return this.http.delete<GerenciaArquivo>(`GerenciaArquivoBanco/DeletaArquivo/${id}`, httpOptions);
  }

  registraArquivoUsuario(obj: GerenciaArquivoUsuario): Observable<GerenciaArquivoUsuario> {
    return this.http.post<GerenciaArquivoUsuario>(`GerenciaArquivoBanco/CadastraUsuarioArquivo`, obj, httpOptions);
  }


  obterGerenciaArquivoUsuarioPorArquivoId(arquivoId: number): Observable<GerenciaArquivoUsuario[]> {
    return this.http.get<GerenciaArquivoUsuario[]>(`GerenciaArquivoBanco/ObterGerenciaArquivoUsuarioPorArquivoId/${arquivoId}`, httpOptions);
  }

  removeArquivoUsuario(id: number): Observable<GerenciaArquivo> {
    return this.http.delete<GerenciaArquivo>(`GerenciaArquivoBanco/DeletaArquivoUsuario/${id}`, httpOptions);
  }

  ObterArquivosPorUsuario(username: string) {
    return this.http.get<GerenciaArquivo[]>(`GerenciaArquivoBanco/ObterArquivosPorUsuario/${username}`, httpOptions);
  }
}
